import { isDataImageUrl } from './localizeImageUrl';

/**
 * Quita imágenes embebidas (data:) del spec enviado al API de preview.
 * El SQL no usa la imagen de fondo; incluirla infla el POST y provoca 413 en nginx (~1 MB por defecto).
 */
export function specForPreviewApi(spec) {
  if (!spec?.visualization?.backgroundImageUrl) return spec;
  if (!isDataImageUrl(spec.visualization.backgroundImageUrl)) return spec;
  return {
    ...spec,
    visualization: {
      ...spec.visualization,
      backgroundImageUrl: undefined,
    },
  };
}

/**
 * Guarda la imagen base64 una sola vez (en heatmapGridConfig / imageDensityConfig)
 * y la quita de visualizationSpec para reducir el payload de /api/dashboards/save.
 */
export function sanitizeChartForDashboardSave(chart) {
  if (!chart) return chart;
  const viz = chart.visualizationSpec;
  const vizBg = viz?.visualization?.backgroundImageUrl;
  if (!vizBg || !isDataImageUrl(vizBg)) return chart;

  const hasHeatmap = chart.type === 'heatmapGrid' || chart.heatmapGridConfig;
  const hasDensity =
    chart.type === 'imageDensity' ||
    chart.imageDensityConfig ||
    chart.advancedConfig?.imageDensityConfig;

  if (hasHeatmap) {
    return {
      ...chart,
      heatmapGridConfig: {
        ...(chart.heatmapGridConfig || {}),
        backgroundImageUrl: chart.heatmapGridConfig?.backgroundImageUrl || vizBg,
      },
      visualizationSpec: {
        ...viz,
        visualization: {
          ...viz.visualization,
          backgroundImageUrl: undefined,
        },
      },
    };
  }

  if (hasDensity) {
    const idCfg = chart.imageDensityConfig || chart.advancedConfig?.imageDensityConfig || {};
    return {
      ...chart,
      imageDensityConfig: { ...idCfg, backgroundImageUrl: vizBg },
      advancedConfig: {
        ...(chart.advancedConfig || {}),
        imageDensityConfig: {
          ...(chart.advancedConfig?.imageDensityConfig || idCfg),
          backgroundImageUrl: vizBg,
        },
      },
      visualizationSpec: {
        ...viz,
        visualization: {
          ...viz.visualization,
          backgroundImageUrl: undefined,
        },
      },
    };
  }

  return chart;
}

export function sanitizeDashboardForSave(dashboard) {
  if (!dashboard?.charts?.length) return dashboard;
  return {
    ...dashboard,
    charts: dashboard.charts.map(sanitizeChartForDashboardSave),
  };
}
